module.exports = __webpack_public_path__ + "img/simple_logo-on.a892286f.svg";